module.exports = __webpack_public_path__ + "static/media/pluswhite.de659a40.svg";